import React, { useState } from "react";
import "../css/Tooltip.css";

const Tooltip = ({ text, children }) => {
    const [isVisible, setIsVisible] = useState(false);

    const showTooltip = () => setIsVisible(true);
    const hideTooltip = () => setIsVisible(false);

    return (
        <div
            className="tooltip-container"
            onMouseEnter={showTooltip}
            onMouseLeave={hideTooltip}
            style={{ position: "relative", display: "inline-block" }}
        >
            {children}
            {isVisible && (
                <div className="tooltip-content">
                    {text}
                </div>
            )}
        </div>
    );
};

export default Tooltip;
